const countIssues = {
  content_readability_ari: (value, prev = 0) => 0,
  content_readability_coleman_liau: (value, prev = 0) => 0,
  content_readability_dale_chall: (value, prev = 0) => 0,
  content_readability_flesh_kincaid: (value, prev = 0) => 0,
  description_length: (value, prev = 0) => 0,
  duplicate_description: (value, prev = 0) => (value ? prev + 1 : prev),
  duplicate_title: (value, prev = 0) => (value ? prev + 1 : prev),
  h1_count: (value, prev = 0) => (value > 1 ? prev + 1 : prev),
  have_flash: (value, prev = 0) => (value ? prev + 1 : prev),
  have_frame: (value, prev = 0) => (value ? prev + 1 : prev),
  have_lorem_ipsum: (value, prev = 0) => (!value ? prev + 1 : prev),
  have_page_duplicates: (value, prev = 0) => (!value ? prev + 1 : prev),
  images_invalid_alt: (value, prev = 0) => (value > 0 ? prev + 1 : prev),
  images_invalid_title: (value, prev = 0) => (value > 0 ? prev + 1 : prev),
  external_links: (value, prev = 0) => (value > 100 ? prev + 1 : prev),
  internal_links: (value, prev = 0) => (value === 0 ? prev + 1 : prev),
  links_broken: (value, prev = 0) => (value > 0 ? prev + 1 : prev),
  meta_noindex: (value, prev = 0) => (!value ? prev + 1 : prev),
  number_of_redirects: (value, prev = 0) => (value > 5 ? prev + 1 : prev),
  referrer_pages: (value, prev = 0) => (value <= 1 ? prev + 1 : prev),
  seo_friendly_url: (value, prev = 0) => 0,
  status_code: (value, prev = 0) => (value >= 400 ? prev + 1 : prev),
  title_length: (value, prev = 0) => (value > 70 ? prev + 1 : prev),
  url: (value, prev = 0) => (/\/$/.test(new URL(value).pathname) ? prev : prev + 1),
  url_characters_check: (value, prev = 0) => 0,
  url_length_ok: (value, prev = 0) => 0,
  word_count: (value, prev = 0) => (value < 250 ? prev + 1 : prev)
}

export const processAuditIssues = (data, initialState) => {
  const auditIssues = { ...initialState }
  data.forEach(item => {
    for (const key in item.attributes.page) {
      if (typeof auditIssues[key] !== 'undefined' && typeof countIssues[key] !== 'undefined') {
        auditIssues[key] = countIssues[key](item.attributes.page[key], auditIssues[key])
      }
    }
  })
  return auditIssues
}
